import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
	StatementArticle,
	StatementCategory,
	StatementCategoryDetails,
} from '../models/statements.models';
import { EnvironmentApiService } from '@uc/utilities';

@Injectable({
	providedIn: 'root',
})
export class StatementsApiService {
	constructor(
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	getAllCategories(): Observable<StatementCategory[]> {
		return this._http.get<StatementCategory[]>(
			`${this._apiSrv.API_URL}personal-statements`,
		);
	}

	getStatementsByCategory(slug: string): Observable<StatementCategoryDetails> {
		return this._http.get<StatementCategoryDetails>(
			`${this._apiSrv.API_URL}personal-statements/${slug}`,
		);
	}

	getStatementArticle(
		categorySlug: number,
		statementSlug: string,
	): Observable<StatementArticle> {
		return this._http.get<StatementArticle>(
			`${this._apiSrv.API_URL}personal-statements/${categorySlug}/statements/${statementSlug}`,
		);
	}
}
